import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Select,
  MenuItem,
  withStyles,
  Theme,
  createStyles,
  InputBase,
} from '@material-ui/core';

import { Scenes } from '../../../../types/items';
import { selectCurrentSceneId } from '../../../../store/modules/scenes/selectors';
import { setCurrentSceneId } from '../../../../store/modules/scenes/actions';
import { updateQuery } from '../../../../utility/helpers';

type Props = {
  scripts: Scenes[];
  disabled?: boolean;
};

/* eslint-disable react/no-array-index-key */

const ScriptListAction = ({ scripts, disabled = false }: Props) => {
  const currentSceneId = useSelector(selectCurrentSceneId);
  const dispatch = useDispatch();

  /*
  useEffect(() => {
    if (scripts.length > 0) {
      const currentScript = scripts.find((item) => item.id === currentSceneId);
      if (currentScript === undefined) {
        dispatch(setCurrentSceneId(scripts[0].id));
      }
    }
  }, [dispatch, scripts, currentSceneId]);
  */

  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
    const scriptId = event.target.value as number;
    updateQuery({ scriptId });
    dispatch(setCurrentSceneId(scriptId));
  }, [dispatch]);

  return (
    <>
      {(scripts && scripts.length && scripts.some((script) => script.id === currentSceneId))
        ? (
          <Select
            value={currentSceneId}
            onChange={onChange}
            input={<StyledInput />}
            style={{ width: '100%' }}
            MenuProps={{
              disablePortal: false,
              style: {
                zIndex: 2147483101,
              },
            }}
            disabled={disabled}
          >
            {
              scripts.map((item) => (
                <MenuItem style={{ fontSize: 14 }} key={item.id} value={item.id}>
                  {item.title}
                </MenuItem>
              ))
            }
          </Select>
        )
        : null}
    </>
  );
};

const StyledInput = withStyles(({ palette }: Theme) => createStyles({
  input: {
    fontSize: 14,
    borderRadius: 3,
    position: 'relative',
    border: `1px solid ${palette.table.border}`,
    padding: '9px 26px 9px 12px',
    '&:focus': {
      borderRadius: 3,
      borderColor: palette.table.border,
    },
  },
}))(InputBase);

export default ScriptListAction;
